import salesTypeEnums from '../../../../variables/ski/school/sales-type-enums';
import statusEnums from '../../../../variables/ski/school/status-type-enums';

const getDefaultState = () => ({
  schools: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
    newSchoolItem: {
      id: undefined,
      exchangeRateGroupId: undefined,
      priceUserAgentId: undefined,
      productsSkiSchoolSeasonId: undefined,
      productsSkiSchoolSeasonPersonCategoryId: undefined,
      productsSkiSchoolSeasonLevelId: undefined,
      productsSkiSchoolSkiTypeId: undefined,
      productsSkiSchoolLessonTypeId: undefined,
      productsSkiSchoolMeetingPointId: undefined,
      status: statusEnums.INITIATED,
      salesType: salesTypeEnums.BOOKING,
      supplierRef: undefined,
      supplierComment: undefined,
      customerComment: undefined,
      weekDay: undefined,
      startDateTime: undefined,
      maxNumberOfPersons: undefined,
      numberOfDays: undefined,
      minutes: undefined,
      price: undefined,
      priceNet: undefined,
      currencyNet: undefined,
      supplierName: undefined,
      seasonName: undefined,
      personCategoryName: undefined,
      levelName: undefined,
      skiTypeName: undefined,
      lessonTypeName: undefined,
      meetingPointName: undefined,
      seasonNameSupplier: undefined,
      personCategoryNameSupplier: undefined,
      levelNameSupplier: undefined,
      skiTypeNameSupplier: undefined,
      lessonTypeNameSupplier: undefined,
      meetingPointNameSupplier: undefined,
      participants: [],
    },
    newSchoolParticipantItem: {
      bookingSkiSchoolId: undefined,
      bookingParticipantId: undefined,
    },
  },
  bookingParticipants: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  availableSchoolProducts: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
  },
  skiTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  meetingPoints: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  search: {
    selectedBookingParticipantId: null,
    selectedLessonTypeId: undefined,
    selectedWeekDayNumber: undefined,
    selectedLessonDuration: undefined,
    selectedLevelId: undefined,
    selectedSkiTypes: [],
    selectedNumberOfPersons: undefined,
    selectedNumberOfDays: undefined,
    availableNumberOfDays: [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14],
    selectedAreaId: null,
  },
  changeProduct: {
    selectedBookingParticipantId: undefined,
    selectedPersonCategoryId: undefined,
    selectedLessonTypeId: undefined,
    selectedWeekDayNumber: undefined,
    selectedLessonDuration: undefined,
    selectedLevelId: undefined,
    selectedSkiTypeId: undefined,
    selectedNumberOfPersons: undefined,
    selectedNumberOfDays: undefined,
    selectedAreaId: null,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/school/defaultState.js